import app from 'flarum/forum/app';

/**
 * Initiates a new discussion by opening the composer
 */
export function initiateNewDiscussion() {
  if (app.session.user) {
    app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
      user: app.session.user
    }).then(() => app.composer.show());
  } else {
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
  }
}
flarum.reg.add('fof-prevent-necrobumping', 'forum/utils/discussionUtils', { initiateNewDiscussion: initiateNewDiscussion, });